import { render } from "./ResetPasswordModal.vue?vue&type=template&id=76b81fc1&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=76b81fc1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76b81fc1"

export default script